import angular from 'angular';

angular.module('cloudX').directive('cxCrmType', [
  'enumCacheSvc',
  function(enumCacheSvc) {
    return {
      restrict: 'E',
      template:
        '<select ng-model="crmType" ng-options="crmType.key as (crmType.key | translateList:\'crmtype\':crmType.value) in crmTypes" class="form-control input-sm"> </select>',
      scope: {
        crmType: '=data',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.crmTypes = [];
          enumCacheSvc.get('crmType').then(function(data) {
            $scope.crmTypes = data;
          });
        },
      ],
    };
  },
]);
